export async function fetchSections(url, sections, signal) {
  const target = new URL(url, location.origin);
  target.searchParams.set('sections', sections.join(','));
  const response = await fetch(target, { signal });
  const data = await response.json();
  const parser = new DOMParser();
  return Object.fromEntries(sections.map((id) => [id, parser.parseFromString(data[id] || '', 'text/html')]));
}

export function swap(doc, root, regions) {
  const active = document.activeElement;
  const key = active?.dataset?.focusKey;
  for (const name of regions) {
    const next = doc.querySelector(`[data-region="${name}"]`);
    const current = root.querySelector(`[data-region="${name}"]`);
    if (next && current) current.replaceWith(document.importNode(next, true));
  }
  if (key) root.querySelector(`[data-focus-key="${key}"]`)?.focus();
}

export async function cartRequest(path, body, sections) {
  const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/${path}`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    body: JSON.stringify(sections.length ? { ...body, sections: sections.join(','), sections_url: location.pathname } : body),
  });
  const data = await response.json();
  if (!response.ok) throw new Error(data.description || data.message || 'Cart error');
  return data;
}

export function emit(name, detail) {
  document.dispatchEvent(new CustomEvent(`cc:${name}`, { detail }));
}
